import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './AboutPage.css';

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <Navigation />
      <main className="about-main">
        <section className="about-hero">
          <h1>About Worldasia</h1>
          <p>
            Worldasia is your gateway to Asian shopping — a marketplace connecting customers with
            authentic vendors for products and services worldwide.
          </p>
        </section>

        <div className="about-grid">
          <section className="about-card">
            <h2>Our mission</h2>
            <p>
              We make multicultural commerce accessible by helping Asian vendors reach new customers
              while giving shoppers a trusted place to discover clothing, electronics, food, beauty,
              digital products, and local services.
            </p>
          </section>

          <section className="about-card">
            <h2>What we offer</h2>
            <ul>
              <li>Curated marketplace categories from vendors across the UK and beyond</li>
              <li>Secure checkout and order tracking for customers</li>
              <li>Vendor tools to list products, manage orders, and get paid through Stripe</li>
            </ul>
          </section>

          <section className="about-card about-contact">
            <h2>Contact</h2>
            <p>
              <a href="tel:+447939060549">07939 060549</a>
              <br />
              <a href="mailto:support@worldasia.co.uk">support@worldasia.co.uk</a>
              <br />
              19 Newton Road, Sparkhill, Birmingham, B11 4PS
            </p>
          </section>
        </div>

        <Link to="/" className="about-back">
          ← Back to Home
        </Link>
      </main>
    </div>
  );
};

export default AboutPage;
